module.exports = __webpack_public_path__ + "static/img/avatar_1.12d2dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/avatar_1.png
// module id = IPNK
// module chunks = 28